import React, { ReactNode } from 'react';
import { Card, CardBody } from 'src/components/ui';
import classnames from 'src/util/classnames';
import { SectionSpan } from './types';
import { useFormLoading } from './FormLoading';

// Literal class names so Tailwind's scanner sees them.
const SPAN_CLASS: Record<SectionSpan, string> = {
  4: 'lg:col-span-4',
  5: 'lg:col-span-5',
  6: 'lg:col-span-6',
  7: 'lg:col-span-7',
  8: 'lg:col-span-8',
  12: 'lg:col-span-12',
};

export type SectionCardProps = {
  span: SectionSpan;
  title: ReactNode;
  hint?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  testId?: string;
};

export function SectionCard({ span, title, hint, actions, children, testId }: SectionCardProps) {
  const loading = useFormLoading();

  return (
    <Card className={classnames('h-full min-w-0', SPAN_CLASS[span])} data-testid={testId}>
      <CardBody>
        <div className="flex flex-wrap items-center gap-2 mb-3">
          <div className="min-w-0">
            {/* `!` because the global h3 size, weight and margin are unlayered and beat Tailwind utilities. */}
            <h3 className="text-sm! font-semibold! leading-tight! m-0!">{title}</h3>
            {hint ? <p className="text-xs opacity-70 m-0">{hint}</p> : null}
          </div>
          {actions ? (
            <div className={classnames('ml-auto flex items-center gap-2', { 'pointer-events-none opacity-50': loading })} aria-disabled={loading || undefined}>
              {actions}
            </div>
          ) : null}
        </div>
        {children}
      </CardBody>
    </Card>
  );
}

export default SectionCard;
